import { RSocketContext } from "../context";
import { RSocketState } from "../types";
import { useContext } from "react";

/**
 * Hook to access RSocket functionality
 * @returns RSocket state and functions
 */
export function useRSocketContext(): RSocketState {
    const context = useContext(RSocketContext);

    if (!context) {
        throw new Error("useRSocket must be used within an RSocketProvider");
    }

    return context;
}
